<template>
  <DropdownField
    inputId="cashless-pay-type"
    name="type"
    :label="t('sites.singleSite.financialConfig.mealPlans.form.planType')"
    :placeholder="t('sites.singleSite.financialConfig.mealPlans.form.planTypePlaceholder')"
    :options="cashlessPayTypes"
    optionLabel="label"
    optionValue="value"
    :required="editCashlessPay"
    :disabled="!editCashlessPay"
  />
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import { useCashlessPay } from '../../composables';
import { storeToRefs } from 'pinia';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { t } = useI18n();

// Set cashless pay composable
const { cashlessPayTypes } = useCashlessPay();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editCashlessPay } = storeToRefs(fConfigStore);
</script>
